import React from "react";
import moment from "moment-mini";
import { View, Text } from "react-native";

import AppTheme from "../../AppTheme";
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";

function getDateTimeFormat(timeStamp, format = 'DD MMM, YYYY') {
    return moment(timeStamp).utcOffset('+05:30').format(format);
}

export function getDashboardConsultDatetime(ts) {
    // get consultation data and time for dashboard UI
    return getDateTimeFormat(ts * 1000, 'DD-MMM-YYYY hh:mm A')
    // 14-Dec-2020 10:27 AM
}

export function getTransactionDatetime(ts) {
    // get trnasaction data and time
    return getDateTimeFormat(ts * 1000, 'ddd, DD MMM, hh:mm A')
    // Mon, 19 Jan, 09:19 PM
}

export function getActivityDatetime(ts) {
    // get consultation data and time for consultation view UI
    return getDateTimeFormat(ts * 1000, 'dddd DD MMMM, hh:mm A');
    // Tuesday 20 January, 03:29 AM
}

export function getConsultationFullDatetime(ts) {
    // get consultation data and time for consultation view UI
    return getDateTimeFormat(ts * 1000, 'dddd DD MMM YYYY, hh:mm A');
    // Friday 22 May 2020, 06:14 PM
}

export function getOrderDatetime(ts) {
    return getDateTimeFormat(ts * 1000, 'DD MMM, YYYY') + ' at ' +
        getDateTimeFormat(ts * 1000, 'hh:mm A');
    // 15 Feb, 2021 at 02:24 PM
}

export function getAayuCardActivityDatetime(ts) {
    // get aayucard last activity data
    return getDateTimeFormat(ts * 1000, 'DD MMM, YYYY');
    // 05 Aug, 2020
}

export function getAayuCardValidityDateTime(ts) {
    // get aayucard validity data and time
    return getDateTimeFormat(ts * 1000, 'DD-MM-YYYY');
    // 01-08-2020
}

export function getDOBDateTime(date: any) {
    // get DOB data and time
    return moment.unix(date).format('YYYY-MM-DD');
    // 2000-01-23
}

export function getOMSDetailsDateTime(ts) {
    return getDateTimeFormat(ts * 1000, 'DD MMM, YYYY') + ' at ' +
        getDateTimeFormat(ts * 1000, 'hh:mm A')
    // 31st May, 2021 at 02:24 PM
}

export function getOMSListDateTime(ts) {
    return getDateTimeFormat(ts * 1000, 'DD MMM, YYYY') + ' at ' +
        getDateTimeFormat(ts * 1000, 'hh:mm A');
    // 15 Feb, 2021 at 02:24 PM
}

export function getConsultationCallTime(ts) {
    return getDateTimeFormat(ts * 1000, 'hh:mm A');
    // 02:15 AM
}

export function getAayuCardValidDays(ts) {
    // get aayuacard valid days
    // return moments(ts - new Date().getTime())
    // .utcOffset('05:30')
    // .format('DDD');
    // get aayuacard remaining valid days
    var validityDay = parseInt(getDateTimeFormat(ts * 1000, 'DDD'));
    var validityYear = parseInt(getDateTimeFormat(ts * 1000, 'YYYY'));
    var currentDay = parseInt(moment().utcOffset('05:30').format('DDD'));
    var currentYear = parseInt(moment().utcOffset('05:30').format('YYYY'));
    return validityDay - currentDay + ((validityYear - currentYear) * 365);
}

export function getAgeFromTs(date: any) {
    var age = moment().diff(moment.unix(date).format('YYYY-MM-DD'), 'years');
    return age;
}

export function getTsFromAge(age: any) {
    var dob = moment().subtract(age, 'years').valueOf() / 1000;
    return dob;
}

export function daystomonths(days: any) {
    return Math.round(days / 30);
}

export function ifMultipleMonths(days: any) {
    return daystomonths(days) > 1 ? 's' : '';
}

export function getEpochTime(date: any) {
    return moment(date, "YYYY-MM-DD").valueOf() / 1000;
}

export function getTimeRange(startingTime, closingTime) {
    startingTime = (startingTime / 60) >= 12 ? ` ${(startingTime / 60 - 12) >= 10 ? '' : '0'}${Math.trunc(startingTime / 60 - 12)}:${(startingTime % 60) >= 10 ? '' : '0'}${startingTime % 60} PM` : `${(startingTime / 60) >= 10 ? '' : '0'}${Math.trunc(startingTime / 60)}:${(startingTime % 60) > 10 ? '' : '0'}${startingTime % 60} AM`;
    closingTime = (closingTime / 60) >= 12 ? `${(closingTime / 60 - 12) >= 10 ? '' : '0'}${Math.trunc(closingTime / 60 - 12)}:${(closingTime % 60) >= 10 ? '' : '0'}${closingTime % 60} PM` : `${(startingTime % 60) >= 10 ? '' : '0'}${Math.trunc(closingTime / 60)}:${(closingTime % 60) > 10 ? '' : '0'}${closingTime % 60} AM`;
    return startingTime + ' to ' + closingTime


}

export function getstoreOpenStatus(startingTime, closingTime) {
    let now = new Date().getHours();

    if (now >= (startingTime / 60) && now <= (closingTime / 60)) {
        return 'Open now'
    } else {
        return 'Closed now'
    }
}

export function getStoreOpenTime(pharmacyData) {
    var openTimeInMinutes = pharmacyData['storeSettings']['timing']['start'] // in IST
    openTimeInMinutes = openTimeInMinutes - 330 // to UTC
    const openTimeInSeconds = (openTimeInMinutes) * 60
    return getDateTimeFormat(openTimeInSeconds * 1000, 'hh:mm A');
    // 02:15 AM
}

function checkIsCurrentTimeAfter(givenHours, givenMinutes, now_hours, now_minutes) {
    if (now_hours > givenHours)
        return true
    else if (now_hours == givenHours) {
        if (now_minutes > givenMinutes)
            return true
        else return false
    } else if (now_hours < givenHours)
        return false
}

export function isStoreClosed(pharmacyData) {
    if (pharmacyData?.storeSettings && pharmacyData?.storeSettings?.timing) {
        const openTimeInMinutes = pharmacyData['storeSettings']['timing']['start'] // in IST
        const closeTimeInMinutes = pharmacyData['storeSettings']['timing']['end'] // in IST
        const openingHours = (openTimeInMinutes) / 60
        const closingHours = (closeTimeInMinutes) / 60
        const openingMinutes = (openTimeInMinutes) % 60
        const closingMinutes = (closeTimeInMinutes) % 60
        let now_hours = new Date().getHours();
        let now_minutes = new Date().getMinutes();
        if (now_hours < openingHours)
            return true
        else if (now_hours == openingHours) {
            if (now_minutes < openingMinutes)
                return true
            else return checkIsCurrentTimeAfter(closingHours, closingMinutes, now_hours, now_minutes)
        } else return checkIsCurrentTimeAfter(closingHours, closingMinutes, now_hours, now_minutes)
    } else return null
}

export function getMessageDateTime(ts) {
    return isToday(ts) ?
        <Text style={[TextStyle.text12, { color: AppTheme.color.grey.text }]}>
            {getDateTimeFormat(ts * 1000, 'hh:mm A')}</Text> :
        <View style={[AppStyles.flexRow]}>
            <Text style={[TextStyle.text12, { color: AppTheme.color.grey.text }]}>
                {getDateTimeFormat(ts * 1000, 'hh:mm A')}</Text>
            <View style={{ height: 4, width: 4, borderRadius: 12, backgroundColor: "black", marginHorizontal: 6 }} />
            <Text style={[TextStyle.text12, { color: AppTheme.color.grey.text }]}>
                {getDateTimeFormat(ts * 1000, 'DD MMMM')}</Text>
        </View>
}

export function getCommonDateTime(ts) {
    let timestemp = new Date(ts * 1000)
    return isToday(ts) ? 'Today at ' + getDateTimeFormat(timestemp, 'hh:mm A') :
        isYesterday(ts) ? 'Yesterday at ' + getDateTimeFormat(ts * 1000, 'hh:mm A') :
            getDateTimeFormat(ts * 1000, 'DD MMM, YYYY') + ' at ' +
            getDateTimeFormat(ts * 1000, 'hh:mm A');
    // 15 Feb, 2021 at 02:24 PM
}

export function isToday(ts) {
    let timestamp = new Date(ts * 1000)
    let todayDate = moment(new Date(), 'DD-MMMM-dddd')
        .utcOffset('05:30')
        .format('DD-MMMM-dddd');
    let timeStampDate = getDateTimeFormat(timestamp, 'DD-MMMM-dddd')
    return todayDate == timeStampDate
}

export function isYesterday(ts) {
    let timestemp = new Date(ts * 1000)
    let today = new Date();
    let yesterday = new Date(today.setDate(today.getDate() - 1))
    let yesterdatDate = moment(yesterday, 'DD-MMMM-dddd')
        .utcOffset('05:30')
        .format('DD MMMM, dddd')
    let timeStampDate = getDateTimeFormat(timestemp, 'DD-MMMM-dddd')
    return yesterdatDate == timeStampDate
}

export function getWebTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
}